(function ($, d, w) {

    let _w = $(w);

    w.addEventListener(w.ZP_DEFAULT.ZP_EVENT_DOM_READY, onInit);

    function onInit() {
        const elements = $('.zp_slider');
        if (elements.length > 0) {
            elements.each((index, element) => {
                new Slider($(element), $(element).attr('id'));
            });
        }
    }

    class Slider {

        /**
         * Represäntiert ein Slider-Element
         * @constructor
         * @param {object} root - JQuery-Selektor: Slider-Element-Container
         * @param {string} id   - DOM-ID des übergebenen jQuery-Selektors
         */
        constructor(root, id) {


            //Deklariere den Container selbst sowie sämtliche benötigten Elemente innerhalb des Sliders
            this.ELEMENTS = {
                root: root,
                sliderElements: $('#' + id + ' .zp_slider_element'),
                arrows: null, //wird erzeugt nachdem Flickity initialisiert wurde
                dots: null, //wird erzeugt nachdem Flickity initialisiert wurde
                slideImages: $('#' + id + ' .zp_slider_element .zp_element.zp_image'),
                slideTexts: $('#' +id + ' .zp_slider_element .zp_text'),
                textBoxes: $('#' + id + ' .zp_textbox')
            };

            //Deklariere alle via "data" mitgelieferten Informationen
            this.DATA = {
                isLazyload: null,
                imagesLoaded: null,
                customHeight: null,
                arrowsOn: null,
                arrowsVerticalOrientation: null,
                setGallerySize: null,
                adaptiveHeightOn: null,
                slideElementWidth: null,
                slideElementWidthFormat: null,
                dotsOn: null,
                groupCellsOn: null,
                contain: null,
                autoPlay: null,
                draggable: null,
                infiniteSlide: null,
                freeScroll: null,
                initialIndex: null,
                sync: null,
                parallax: null
            };

            //Deklariere alle später übergebenen Flickity-Parameter
            this.flickity = {
                cellSelector: '.zp_slider_element',
                lazyLoad: null,
                imagesLoaded: null,
                prevNextButtons: null,
                setGallerySize: null,
                adaptiveHeight: null,
                pageDots: null,
                groupCells: null,
                contain: null,
                autoPlay: null,
                draggable: null,
                wrapAround: null,
                freeScroll: null,
                initialIndex: null,
                sync: null
            };

            //Sonstige Deklarationen
            this.id = id;
            this.slider = this.ELEMENTS.root; //Flickity-Slider (jQuery)
            this.flickityData = null; //Flickity-Slider (Natives JavaScript)

            //Initialisiere das Hauptprogramm
            this.init();
        }

        /**
         * Initialisiere das Hauptprogramm
         */
        init() {

            //Nach erfolgreicher Flickity-Initialisierung
            this.onEvent( () => {
                let whileSliderDataIsUndefined = setInterval(() => {

                    if (this.slider.data('flickity') !== typeof undefined) {
                        clearInterval(whileSliderDataIsUndefined);
                        this.flickityPostProcessing();
                    }
                    else {
                        //this.slider.data('flickity') ist noch "undefined"
                    }

                }, 1);
            }, 'ready.flickity');


            //Falls nicht genug Slide-Elemente zur Verfügung stehen, sollen

            //Initialisiert den Flickity-Slider
            this.initFlickity();


            //Bei Flickity-Inhalten wird manchmal eine falsche Höhe berechnet
            if (this.ELEMENTS.slideImages.length === 0) {
                this.onEvent(()=> {this.flickityData.resize();}, 'load');
            }
            // this.onEvent(()=> {this.flickityData.resize();}, 'trigger');


            //Breakpoints
            if (this.ELEMENTS.root.data('breakpoints').length !== 0) {
                this.initBreakpoints();
            }

        }

        /**
         * Initialisiert den Flickity-Slider
         */
        initFlickity() {

            /****************************/
            /*Anfängliches Slide-Element*/
            /****************************/
            this.DATA.startSlide = this.ELEMENTS.root.data('start-slide');
            this.flickity.initialIndex = this.DATA.startSlide-1;
            if (this.flickity.initialIndex < 0) {
                this.flickity.initialIndex = 0;
            }

            /********/
            /*Bilder*/
            /********/
            this.flickity.lazyload = false;
            this.flickity.imagesLoaded = false;
            if (this.ELEMENTS.slideImages.length >= 0) {
                this.flickity.imagesLoaded = true;
                this.DATA.isLazyload = this.ELEMENTS.root.data('is-lazyload');

                if (this.DATA.isLazyload === true || this.DATA.isLazyload === 'true' || this.DATA.isLazyload === 1) {
                    this.flickity.lazyload = true;
                    // this.ELEMENTS.slideImages.addClass('lazyload-on');
                }
                else {
                    this.flickity.lazyload = false;
                }

            }

            /********************/
            /*Unendliches Sliden*/
            /********************/
            this.DATA.infiniteSlide = this.ELEMENTS.root.data('infinite-slide');
            this.flickity.wrapAround = false;
            if (this.DATA.infiniteSlide === true || this.DATA.infiniteSlide === 'true' || this.DATA.infiniteSlide === 1) {
                this.flickity.wrapAround = true;
            }


            /*************************/
            /*Benutzerdefinierte Höhe*/
            /*************************/
            //TODO: Wenn Viewport zu klein: Bilder verzerren
            this.DATA.customHeight = this.ELEMENTS.root.data('custom-height');
            this.flickity.setGallerySize = true;
            if (typeof this.DATA.customHeight !== 'undefined') {
                this.ELEMENTS.root.css('max-height', this.DATA.customHeight+'px');
                this.ELEMENTS.root.css('height', this.DATA.customHeight+'px');
                // this.ELEMENTS.slideImages.css('height', customHeightData+'px');
                // setGallerySize = false;
            }

            /*****************/
            /*Anpassbare Höhe*/
            /*****************/
            this.DATA.adaptiveHeightOn = this.ELEMENTS.root.data('adaptive-height-on');
            this.flickity.adaptiveHeight = false;
            if (this.DATA.adaptiveHeightOn === true || this.DATA.adaptiveHeightOn === 'true' || this.DATA.adaptiveHeightOn === 1) {
                this.flickity.adaptiveHeight = true;
            }

            /*************/
            /*Gruppierung*/
            /*************/
            this.DATA.groupCellsOn = this.ELEMENTS.root.data('group-cells-on');
            this.flickity.groupCells = false;
            if (this.DATA.groupCellsOn === true || this.DATA.groupCellsOn === 'true' || this.DATA.groupCellsOn === 1) {
                this.flickity.groupCells = true;
            }

            /***********/
            /*Ausfüllen*/
            /***********/
            this.DATA.contain = this.ELEMENTS.root.data('contain');
            this.flickity.contain = false;
            if (this.DATA.contain === true || this.DATA.contain === 'true' || this.DATA.contain === 1) {
                this.flickity.contain = true;
            }

            /********/
            /*Breite*/
            /********/
            this.DATA.slideElementWidth = this.ELEMENTS.root.data('slide-element-width');
            this.DATA.slideElementWidthFormat = this.ELEMENTS.root.data('slide-element-width-format');
            if (typeof this.DATA.slideElementWidth !== 'undefined') {
                this.ELEMENTS.sliderElements.css('width', this.DATA.slideElementWidth+this.DATA.slideElementWidthFormat);
            }

            /********/
            /*Pfeile*/
            /********/
            this.DATA.arrowsOn = this.ELEMENTS.root.data('arrows-on');
            // let prevNextButtons = (this.DATA.arrowsOn === true || this.DATA.arrowsOn === 'true' || this.DATA.arrowsOn === 1 || this.DATA.arrowsOn === '1');
            this.flickity.prevNextButtons = true;

            /*********************/
            /*Pfeil-Orientiertung*/
            /*********************/
            this.DATA.arrowsVerticalOrientation = parseInt(this.ELEMENTS.root.data('arrows-vertical-orientation'));

            /********/
            /*Punkte*/
            /********/
            this.DATA.dotsOn = this.ELEMENTS.root.data('dots-on');
            // let pageDots = (this.DATA.dotsOn === true || this.DATA.dotsOn === 'true' || this.DATA.dotsOn === 1 || this.DATA.dotsOn === '1');
            this.flickity.pageDots = true;

            /*********/
            /*Autoplay*/
            /*********/
            this.DATA.autoPlay = this.ELEMENTS.root.data('autoplay');
            this.flickity.autoPlay = (this.DATA.autoPlay > 0);

            /*********/
            /*Ziehbar*/
            /*********/
            this.DATA.draggable = this.ELEMENTS.root.data('draggable');
            this.flickity.draggable = false;
            if (this.DATA.draggable === true || this.DATA.draggable === 'true' || this.DATA.draggable === 1) {
                this.flickity.draggable = true;
            }

            /*****************/
            /*Freies Scrollen*/
            /*****************/
            this.DATA.freeScroll = this.ELEMENTS.root.data('free-scroll');
            this.flickity.freeScroll = (this.DATA.freeScroll === true || this.DATA.freeScroll === 'true' || this.DATA.freeScroll === 1);

            /******************/
            /*Synchronisi̱e̱rung*/
            /******************/
            this.DATA.sync = this.ELEMENTS.root.data('sync');
            this.flickity.sync = null;
            if (typeof this.DATA.sync !== 'undefined') {
                this.ELEMENTS.root.addClass(this.DATA.sync);
                this.flickity.sync = '.'+this.DATA.sync;
            }

            /***********************************************/
            /*Betätige Button bei Slide-Element-Fokusierung*/
            /***********************************************/
            this.DATA.clickButtonOnFocus = this.ELEMENTS.root.data('click-button-on-focus');
            this.flickity.clickButtonOnFocus = (this.DATA.clickButtonOnFocus === true || this.DATA.clickButtonOnFocus === 'true' || this.DATA.clickButtonOnFocus == 1);

            /**************************/
            /*Flickity-Initialisierung*/
            /**************************/
            this.slider.flickity({
                cellSelector: this.flickity.cellSelector,
                lazyLoad: this.flickity.lazyload,
                imagesLoaded: this.flickity.imagesLoaded,
                prevNextButtons: this.flickity.prevNextButtons,
                setGallerySize: this.flickity.setGallerySize,
                adaptiveHeight: this.flickity.adaptiveHeight,
                pageDots: this.flickity.pageDots,
                fullscreen: false, //TODO
                groupCells: this.flickity.groupCells,
                contain: this.flickity.contain,
                autoPlay: this.flickity.autoPlay,
                draggable: this.flickity.draggable,
                wrapAround: this.flickity.wrapAround,
                freeScroll: this.flickity.freeScroll,
                initialIndex: this.flickity.initialIndex,
                sync: this.flickity.sync
            });
            console.log(this.flickity.draggable);

        }

        /**
         * Verarbeitung aller Prozesse, die erst nach der Flickity-Initialisierung ausgeführt werden dürfen
         */
        flickityPostProcessing () {

            this.flickityData = this.slider.data('flickity');

            //Pfeile
            this.arrowsPostProcessing();
            //Punkte
            this.dotsPostProcessing();
            //Parallax
            this.parallax();
            //Lazyload
            this.lazyload();
            //Betätige Button bei Slide-Element-Fokusierung
            this.clickButtonOnSlideFocus();
            //Textboxen
            this.textBoxAnimation();

            //Wenn alle Slide-Elemente zu sehen sind, wird das Sliden deaktiviert und die Punkte und Pfeile werden ausgeblendet
            this.disableArrowsDotsAndDraggable();

            //Bernitzky-Intern
            this.setArrowPositionBeforeAndAfterDots();

        }

        /**
         * In dieser Prozedur werden die Pfeile gehandhabt
         */
        arrowsPostProcessing () {

            if (this.flickity.prevNextButtons === true) {

                this.ELEMENTS.arrows = $('#' + this.ELEMENTS.root.attr('id') + ' .flickity-prev-next-button');

                //Farbe
                let arrowsColor = this.ELEMENTS.root.data('arrows-color');
                this.ELEMENTS.arrows.css('color', arrowsColor);

                //Hintergrundfarbe
                let arrowsBackgroundColor = this.ELEMENTS.root.data('arrows-background-color');
                if (arrowsBackgroundColor !== 'transparent') {
                    this.ELEMENTS.arrows.css('background', arrowsBackgroundColor);
                }

                //Farben von ausgewählten Slide-Elementen
                let changeSlideElementArrowColor = () => {

                    let selectedSlideElement = $(this.ELEMENTS.sliderElements[this.flickityData.selectedIndex]);
                    let slideElementArrowColorOn = selectedSlideElement.data('arrows-color-on');

                    if (slideElementArrowColorOn === true || slideElementArrowColorOn === 'true' || slideElementArrowColorOn === 1) {
                        let slideElementArrowColor = selectedSlideElement.data('arrows-color');
                        this.ELEMENTS.arrows.css('color', slideElementArrowColor);
                    }
                    else {
                        this.ELEMENTS.arrows.css('color', arrowsColor);
                    }

                };
                changeSlideElementArrowColor();
                this.onEvent(changeSlideElementArrowColor, 'select.flickity');

                //Pfeil-Orientiertung
                if (this.DATA.arrowsVerticalOrientation !== 0 && (this.DATA.arrowsVerticalOrientation % 1) === 0) { //TODO: Evtl. noch testen

                    let changeTopDistanceOnArrows = () => {

                        let nthChildOnCurrentSlideElement = this.ELEMENTS.root.find('.zp_slider_element.is-selected > .zp_element:nth-child('+this.DATA.arrowsVerticalOrientation+')');

                        let nthChildOnCurrentSlideElementHeight = 0;
                        //Im aktuellen Slide-Element exestiert die benötigte Mindestanzahl an Inhaltselementen
                        if (nthChildOnCurrentSlideElement.length > 0) {
                            nthChildOnCurrentSlideElementHeight = nthChildOnCurrentSlideElement.height();

                            let topValue = (nthChildOnCurrentSlideElementHeight/2);
                            for (let i = 1 ; i < this.DATA.arrowsVerticalOrientation; i++) {

                                if (i  !== this.DATA.arrowsVerticalOrientation) {
                                    let nthSlideElementContent = this.ELEMENTS.root.find('.zp_slider_element.is-selected > .zp_element:nth-child('+i+')');
                                    if (nthSlideElementContent.length > 0) {
                                        topValue += nthSlideElementContent.height();
                                    }
                                }
                                else {
                                    break;
                                }

                            }
                            this.ELEMENTS.arrows.css('top', topValue+'px');
                        }
                        //Es befinden sich zu wenig Inhaltselemente in diesem Slide-Element
                        else {
                            this.ELEMENTS.arrows.css('top', '');
                        }
                    };
                    changeTopDistanceOnArrows();
                    this.onEvent(changeTopDistanceOnArrows, 'select.flickity');

                }

            }

        }

        dotsPostProcessing () {

            if (this.flickity.pageDots === true) {

                this.ELEMENTS.dots = $('#' + this.ELEMENTS.root.attr('id') + ' .flickity-page-dots .dot');
                let dotsBackgroundColor = this.ELEMENTS.root.data('dots-background-color');
                let dotsColor = this.ELEMENTS.root.data('dots-color');

                let changedSlideElementsDotsColor = () => {

                    //Allgemeine Farben
                    this.ELEMENTS.dots = $('#' + this.ELEMENTS.root.attr('id') + ' .flickity-page-dots .dot');

                    //Farbe
                    this.ELEMENTS.dots.css('background', dotsColor);

                    //Hintergrundfarbe
                    if (dotsBackgroundColor !== 'transparent') {
                        this.ELEMENTS.dots.css('border', '5px solid '+dotsBackgroundColor);
                    }

                    //Farben von ausgewählten Slide-Elementen
                    let selectedSlideElement = $(this.ELEMENTS.sliderElements[this.flickityData.selectedIndex]);
                    let slideElementDotsColorOn = selectedSlideElement.data('dots-color-on');
                    if (slideElementDotsColorOn === true || slideElementDotsColorOn === 'true' || slideElementDotsColorOn === 1) {
                        let slideElementDotsColor = selectedSlideElement.data('dots-color');
                        this.ELEMENTS.dots.css('background', slideElementDotsColor);
                    }
                    else {
                        this.ELEMENTS.dots.css('background', dotsColor);
                    }
                };
                changedSlideElementsDotsColor();
                this.onEvent(changedSlideElementsDotsColor, 'select.flickity');

            }

            if (this.flickity.autoPlay !== false && this.flickity.pageDots) {
                this.countDown();
                this.preventPauseAutoPlayOnClick();
            }

        }

        parallax () {

            //Parallax
            this.DATA.parallax = this.ELEMENTS.root.data('parallax-on');
            if (this.DATA.parallax === true || this.DATA.parallax === 'true' || this.DATA.parallax === 1) {

                let slideElementsContentChildrens = [];
                this.ELEMENTS.sliderElements.each((index, slideElementContentChildrens) => {
                    slideElementsContentChildrens.push($(slideElementContentChildrens).children());
                });

                //TODO: Bei zwei Slide-Elementen
                // //unendlicher Slide und 2 Slide-Elemente
                // let slideElementsSecendContent = null;
                // if (wrapAround && this.flickityData.slides.length === 2) {
                //     let flickitySlider = this.ELEMENTS.root.find('.flickity-slider');
                //     this.flickityData.cells.forEach( ( slide, i ) => {
                //
                //         $(slide.element).append($(slide.element)[0].children[0].outerHTML);
                //         let slideElementSecendContent = $('#' + $(slide.element).attr('id') + ' > *:last-child');
                //         slideElementSecendContent.addClass('flickity-secend-slide-content');
                //         slideElementSecendContent.css({
                //             position: 'absolute',
                //             top: '0',
                //             zIndex: '-1',
                //             width: '100%',
                //             height: '100%'
                //         });
                //
                //     });
                //     slideElementsSecendContent = this.ELEMENTS.sliderElements.find(' > *:last-child');
                // }


                // get transform property
                let docStyle = document.documentElement.style;
                let transformProp = typeof docStyle.transform == 'string' ? 'transform' : 'WebkitTransform';

                let parallaxSlide = () => {

                    if (!this.flickity.wrapAround) {
                        this.flickityData.cells.forEach( ( slide, i ) => {

                            let x = ( slide.target + this.flickityData.x ) * -1/3;
                            //Alle Kinder stylen
                            slideElementsContentChildrens[i].each((index, slideElementContentChildren) => {
                                slideElementContentChildren.style[ transformProp ] = 'translateX(' + x  + 'px)';
                            });

                        });
                    }
                    //bei unendlichen Sliden
                    else {

                        //TODO: Bei zwei Elementen
                        // //bei 2 Slide-Elementen
                        // if (this.flickityData.slides.length === 2) {
                        //     this.flickityData.cells.forEach( ( slide, i ) => {
                        //         let slideElementContent = slideElementsContent[i];
                        //         let slideElementSecendContent = slideElementsSecendContent[i];
                        //         let xFirstContent   = 0;
                        //         let xSecendContent   = 0;
                        //         if( 0 === i ) {
                        //             xFirstContent = Math.abs( this.flickityData.x ) > this.flickityData.slidesWidth ? ( this.flickityData.slidesWidth +this.flickityData.x + this.flickityData.slides[this.flickityData.slides.length - 1 ].outerWidth + slide.target ) : ( slide.target + this.flickityData.x );
                        //             xSecendContent = ( slide.target + this.flickityData.x );
                        //         }
                        //         else if( i === this.flickityData.slides.length - 1 ) {
                        //             xFirstContent = Math.abs( this.flickityData.x ) + this.flickityData.slides[i].outerWidth < this.flickityData.slidesWidth ? ( slide.target - this.flickityData.slidesWidth + this.flickityData.x - this.flickityData.slides[i].outerWidth ) : ( slide.target + this.flickityData.x );
                        //
                        //             if (this.flickityData.selectedIndex === 1) {
                        //                 xSecendContent = ( slide.target - this.flickityData.slidesWidth + this.flickityData.x - this.flickityData.slides[i].outerWidth );
                        //             }
                        //             else {
                        //                 xSecendContent = ( slide.target - this.flickityData.slidesWidth + this.flickityData.x - this.flickityData.slides[i].outerWidth );
                        //             }
                        //         } else {
                        //             xFirstContent = slide.target + this.flickityData.x;
                        //         }
                        //
                        //         slideElementContent.style[ transformProp ] = 'translateX(' + xFirstContent * ( -1 / 3 ) + 'px)';
                        //         slideElementSecendContent.style[ transformProp ] = 'translateX(' + xSecendContent * ( -1 / 3 ) + 'px)';
                        //
                        //     });
                        // }
                        // //bei mehr als 2 Slide-Elementen
                        // else {
                        this.flickityData.cells.forEach( ( slide, i ) => {

                            let x   = 0;
                            if (this.flickityData.cells.length === 1) {
                                //Alle Kinder stylen
                                slideElementsContentChildrens[i].each((index, slideElementContentChildren) => {
                                    slideElementContentChildren.style[ transformProp ] = 'translateX(0)';
                                });
                            }
                            else {
                                if( 0 === i ) {
                                    x = Math.abs( this.flickityData.x ) > this.flickityData.slidesWidth ? ( this.flickityData.slidesWidth +this.flickityData.x + this.flickityData.slides[this.flickityData.slides.length - 1 ].outerWidth + slide.target ) : ( slide.target + this.flickityData.x );
                                } else if( i === this.flickityData.slides.length - 1 ) {
                                    x = Math.abs( this.flickityData.x ) + this.flickityData.slides[i].outerWidth < this.flickityData.slidesWidth ? ( slide.target - this.flickityData.slidesWidth + this.flickityData.x - this.flickityData.slides[i].outerWidth ) : ( slide.target + this.flickityData.x );
                                } else {
                                    x = slide.target + this.flickityData.x;
                                }

                                //Alle Kinder stylen
                                slideElementsContentChildrens[i].each((index, slideElementContentChildren) => {
                                    slideElementContentChildren.style[ transformProp ] = 'translateX(' + x * ( -1 / 3 ) + 'px)';
                                });
                            }

                        });
                        //TODO: Bei zwei Slide-Elementen
                        // }


                    }

                };

                this.onEvent(parallaxSlide, 'scroll.flickity');
                //TODO: Bei zwei Elementen
                // //unendlicher Slide und 2 Slide-Elemente
                // if (wrapAround && this.flickityData.slides.length === 2) {
                //     this.onEvent(() => {slideElementsSecendContent.css('z-index', '-1');}, 'settle.flickity');
                // }

            }


        }

        lazyload () {

            //Fügt allen "is-selected"-Elementen "srcset" hinzu
            //TODO: Lazyload in Verbindung mit Flickity-Lazyload
            // if (lazyload === true) {
            //
            //     this.slideImageSrcDatas = [];
            //     this.ELEMENTS.slideImages.each((index, slideImage) => {
            //
            //         let _slideImage = $(slideImage);
            //         let _slideImageSrc = $('#'+_slideImage.attr('id') + ' > img');
            //
            //         //Lazyload für einzelnes Bild aktiviert
            //         if (_slideImageSrc[0].hasAttribute("data-srcset")) {
            //             let slideImageSrcData = _slideImageSrc.attr('data-srcset');
            //             this.slideImageSrcDatas.push(slideImageSrcData);
            //         }
            //
            //         _slideImageSrc.attr('data-flickity-lazyload', 'http://localhost/projekte/Arbeit/Suesges/deployment/wp-content/uploads/2018/02/hearthstone-screenshot-02-01-18-22-17-38.png');
            //     });
            //
            // }
            //
            // let testiko = () => {
            //     // console.log(this.flickityData.selectedIndex);
            //     let _selectedElement = $(this.flickityData.selectedElement);
            //     let _selectedElementImgs = $('#'+_selectedElement.attr('id')+ ' .zp_element.zp_image img')
            //
            //     _selectedElementImgs.each((index, slideImage) => {
            //         console.log(slideImage);
            //         let _slideImage = $(slideImage);
            //         _slideImage.attr('srcset', _slideImage.attr('data-srcset'));
            //     });
            //
            //     // let dataSrc = $('#'+this.flickityData.slides[this.flickityData.selectedIndex].attr('id')+ ' > img').attr('srcset', );
            // };
            //
            // this.onEvent(testiko, 'select.flickity');

        }

        disableArrowsDotsAndDraggable () {

            let disableArrowsDotsAndDraggable = () => {

                if ($('#' + this.ELEMENTS.root.attr('id') + ' .zp_slider_element.is-selected').length === this.ELEMENTS.sliderElements.length) {
                    this.ELEMENTS.root.addClass('all-slide-elements-visible');
                    this.flickityData.unbindDrag();
                }
                else {
                    this.ELEMENTS.root.removeClass('all-slide-elements-visible');
                    if (this.flickity.draggable) {
                        this.flickityData.bindDrag();
                    }
                }

            };
            disableArrowsDotsAndDraggable();
            this.onEvent(disableArrowsDotsAndDraggable, 'select.flickity');

        }

        clickButtonOnSlideFocus () {

            if (this.DATA.clickButtonOnFocus === true || this.DATA.clickButtonOnFocus === 'true' || this.DATA.clickButtonOnFocus === 1) {
                let clickButtonOnFocusFunction = () => {
                    let currentSlideElement = $(this.flickityData.selectedSlide.cells[0].element);
                    // console.log(currentSlideElement.find('.zp-slider-auto-click'));
                    currentSlideElement.find('button').click();
                    currentSlideElement.find('.zp-slider-auto-click').click();
                };
                clickButtonOnFocusFunction();

                // this.onEvent(()=> {clickButtonOnFocusFunction();}, 'trigger');
                this.onEvent(clickButtonOnFocusFunction, 'change.flickity');
            }

        }

        textBoxAnimation () {

            let visibleTextboxes = () => {

                let nextSlideElement = $(this.flickityData.selectedSlide.cells[0].element);
                let nextSlideElementTextbox = nextSlideElement.find('.zp_textbox');

                // console.log(nextSlideElement);

                this.ELEMENTS.textBoxes.removeClass('visible');
                nextSlideElementTextbox.addClass('visible');

            };
            visibleTextboxes();
            this.onEvent(visibleTextboxes, 'select.flickity');

        }


        initBreakpoints ()  {

            let breakpointsData = this.ELEMENTS.root.data('breakpoints');
            let responsiveFirstAddedClassesData = (this.ELEMENTS.root.data('responsive-first-added-classes') != null ? this.ELEMENTS.root.data('responsive-first-added-classes') : '');
            let responsiveFirstRemovedClassesData = (this.ELEMENTS.root.data('responsive-first-removed-classes') != null ? this.ELEMENTS.root.data('responsive-first-removed-classes') : '');

            //Breakpoints definieren
            let breakpoints = [];
            for (let i = 0 ; i < breakpointsData.length ; i++) {

                let breakpointExist = false;
                for (let j = 0; j < breakpoints.length ; j++) {

                    if (breakpointsData[i][0] == breakpoints[j])
                        breakpointExist = true;

                }
                if (!breakpointExist)
                    breakpoints.push([breakpointsData[i][0]]);

            }
            breakpoints.sort((a,b) =>{return b - a});

            //füge zu entfernende oder einzufügende Klassen den Breakpoints hinzu
            for (let i = 0 ; i < breakpoints.length ; i++) {

                let addBreakpointClasses = '';
                let removeBreakpointClasses = '';
                let addBreakpointClassesFirst = '';
                let removeBreakpointClassesFirst = '';
                for (let j = 0; j < breakpointsData.length ; j++) {

                    if (breakpointsData[j][0] == breakpoints[i]) {
                        if (breakpointsData[j][2] === 1) {
                            addBreakpointClasses += breakpointsData[j][1]+' ';
                        }
                        else {
                            removeBreakpointClasses += breakpointsData[j][1]+' ';
                        }
                        if (breakpointsData[j][3] != null) {
                            addBreakpointClassesFirst += breakpointsData[j][3]+' ';
                        }
                        if (breakpointsData[j][4] != null) {
                            removeBreakpointClassesFirst += breakpointsData[j][4]+' ';
                        }
                    }

                }
                breakpoints[i].push(addBreakpointClasses);
                breakpoints[i].push(removeBreakpointClasses);
                breakpoints[i].push(addBreakpointClassesFirst);
                breakpoints[i].push(removeBreakpointClassesFirst);

            }

            let changedClassesOnBreakpoints = () => {

                let windowWidth = _w.width();

                this.ELEMENTS.root.removeClass(responsiveFirstRemovedClassesData);
                this.ELEMENTS.root.addClass(responsiveFirstAddedClassesData);

                for (let i = 0 ; i < breakpoints.length ; i++) {

                    if (windowWidth < breakpoints[i][0]) {

                        this.ELEMENTS.root.removeClass(breakpoints[i][4] );
                        this.ELEMENTS.root.addClass(breakpoints[i][3] );
                        this.ELEMENTS.root.removeClass(breakpoints[i][2]);
                        this.ELEMENTS.root.addClass(breakpoints[i][1]);

                    }

                }

            };

            changedClassesOnBreakpoints();
            this.onEvent(changedClassesOnBreakpoints, 'resize');

        }

        /*
        TODO: spezielle Funktion für Brandlounge
         */

        countDown () {

            this.ELEMENTS.dots.append(
                '<svg\n' +
                '  class="progress-ring"\n' +
                '  height="30"\n' +
                '  width="30"\n' +
                '>\n' +
                '  <circle\n' +
                '    class="progress-ring__circle"\n' +
                '    stroke-width="5"\n' +
                '    fill="transparent"\n' +
                '    style=""\n' +
                '    r="11"\n' +
                '    cx="15"\n' +
                '    cy="15"\n' +
                '  />\n' +
                '</svg>'
            );


            function setProgress(percent, circle, circumference) {
                const offset = circumference - percent / 100 * circumference;
                circle.style.strokeDashoffset = offset;
            }


            let circles =  this.ELEMENTS.root.find('circle');

            let radius = circles[0].r.baseVal.value;
            let circumference = radius * 2 * Math.PI;


            circles.css({
                strokeDasharray: `${circumference} ${circumference}`,
                strokeDashoffset: `${circumference}`,
                transition: this.DATA.autoPlay + 'ms stroke-dashoffset linear'
            });


            let setNewCountdownCircleFunc = () => {

                circles.css({
                    strokeDashoffset: `${circumference}`,
                    transition: '0s stroke-dashoffset'
                });
                let circle =  this.ELEMENTS.root.find('.dot.is-selected circle')[0];
                $(circle).css('transition', (this.DATA.autoPlay-200) + 'ms stroke-dashoffset linear');
                setTimeout(() => {
                    setProgress(100, circle, circumference);
                }, 0);

            };

            setNewCountdownCircleFunc();
            this.onEvent(setNewCountdownCircleFunc, 'change.flickity');

        }
        preventPauseAutoPlayOnClick() {

            let preventPauseAutoPlayOnClickFunc = () => {
                this.flickityData.playPlayer();
            };

            this.onEvent(preventPauseAutoPlayOnClickFunc, 'click');

        }

        /*
        TODO: spezielle Funktion für Brandlounge (ENDE)
         */

        onNoSlide () {



        }

        onEvent(func, event) {

            //Seite geladen
            if (event === 'load') {
                _w.on(ZP_DEFAULT.ZP_EVENT_DOM_LOAD, () => {
                    func();
                });
            }

            //beim Ändern der Viewportgröße
            else if (event === 'resize') {
                _w.on('resize', () => {
                    func();
                });
            }

            //Flickity geladen
            else if (event === 'ready.flickity') {
                this.slider.on('ready.flickity', () => {
                    func();
                });
            }

            //beim Ändern der Viewportgröße innerhalb von Flickity
            else if (event === 'resize.flickity') {
                _w.on('resize.flickity', () => {
                    func();
                });
            }

            //sofort beim Sliden
            else if (event === 'select.flickity') {
                this.slider.on('select.flickity', () => {
                    func();
                });
            }

            //wenn sich das aktuelle Slide-Element ändert
            else if (event === 'change.flickity') {
                this.slider.on( 'change.flickity', () => {
                    func();
                });
            }

            //während des Slidens
            else if (event === 'scroll.flickity') {
                this.slider.on('scroll.flickity', () => {
                    func();
                });
            }

            //nach dem Sliden
            else if (event === 'settle.flickity') {
                this.slider.on('settle.flickity', () => {
                    func();
                });
            }

            //beim Laden eines Bildes mit Flickity-Lazyload
            else if (event === 'lazyload') {
                this.slider.on( 'lazyLoad.flickity', () => {
                    func();
                });
            }

            //wenn ein Slide-Prozess beendet ist
            else if (event === 'click') {
                this.ELEMENTS.root.on('click', () => {
                    func();
                });
            }

            //Seite geladen
            // if (event === 'trigger') {
            //     _w.on(ZP_TRIGGER, () => {
            //         func();
            //     });
            // }

        }

        //Wird nur bei Martin Bernitzky verwendet
        //Die Pfeile soollen links und rechts neben den Dots angeordnet werden, sofern die Pfeile und die Dots unten zentriert angeordnet sind
        setArrowPositionBeforeAndAfterDots () {

            let dotsWidth = this.ELEMENTS.root.find('.flickity-page-dots').width();
            let arrowLeft = this.ELEMENTS.root.find('.flickity-prev-next-button.previous');
            let arrowRight = this.ELEMENTS.root.find('.flickity-prev-next-button.next');
            if (this.ELEMENTS.root.hasClass('arrow-left-position-center-bottom') && this.slider.hasClass('arrow-right-position-center-bottom') && this.slider.hasClass('dots-position-center-bottom')) {

                arrowLeft.css('transform','translateX(calc(-50% - '+((dotsWidth/2)+30)+'px))');
                arrowRight.css('transform','translateX(calc(-50% + '+((dotsWidth/2)+30)+'px))');

            }

        }

    }

})(jQuery, document, window);